'use client'

import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { Sprout, BookOpenText } from 'lucide-react'
import { ScreenshotZoom } from './ScreenshotZoom'
import { CheckMark } from './CheckMark'

interface FeatureInspirationProps {
  hideVideoButton?: boolean
}

const BULLET_KEYS = ['bullet1', 'bullet2', 'bullet3'] as const

export function FeatureInspiration({ hideVideoButton }: FeatureInspirationProps = {}) {
  const t = useTranslations('features.inspiration')
  return (
    <div className="flex flex-col gap-[20px]">
      {/* Main feature row */}
      <div className="flex flex-wrap gap-[16px] items-start">
        {/* Phone screenshot (clickable) */}
        <ScreenshotZoom src="/images/feature-inspiration.png" alt={t('imageAlt')} />

        {/* Content */}
        <div className="flex flex-col gap-[6px] flex-1 min-w-0 break-words hyphens-auto">
          {/* Icon */}
          <div className="w-[24px] h-[24px]">
            <Sprout size={24} strokeWidth={2} className="text-[#6B8E6B]" />
          </div>

          {/* Text */}
          <div className="flex flex-col gap-[4px] pt-[2px]">
            <p className="text-xl font-bold">{t('title')}</p>
            <p className="text-l">{t('desc')}</p>
          </div>

          {/* Zoom button */}
        </div>
      </div>

      {/* Checklist */}
      <div className="flex flex-col gap-[20px] mt-[8px]">
        {BULLET_KEYS.map((key) => (
          <div key={key} className="flex gap-[12px] items-start">
            <div className="shrink-0">
              <CheckMark size={28} color="#6B8E6B" />
            </div>
            <p className="text-l">
              {t.rich(key, { b: (chunks) => <strong>{chunks}</strong> })}
            </p>
          </div>
        ))}
      </div>

      {/* Inspiration Library CTA */}
      <hr className="border-t border-dashed border-black mt-[24px]" />
      <div className="pt-[24px] pb-[12px] flex justify-center">
        <Link
          href="/inspiration"
          className="inline-flex items-center gap-[12px] px-[24px] py-[14px] bg-black text-[#F7F1E7] text-l font-bold rounded-[8px] cursor-pointer"
        >
          <BookOpenText size={24} strokeWidth={2} />
          {t('libraryCta')}
        </Link>
      </div>
    </div>
  )
}
